let location = window.location.hostname;
let brand = location.split("-")[0];
let apiPath;
if (location.includes("ngrok") || location.includes("localhost"))
  apiPath = process.env.VUE_APP_API;
else apiPath = process.env.VUE_APP_API;

export default apiPath;
